import {uniqBy} from "lodash"
import {ApolloState} from "../apolloStateInterface"

type QueryVariables = {
  query: any,
  variables: {[key: string]: any}
}

export default function hasMorePagination({query, variables}: QueryVariables, apollo: ApolloState, key = Object.keys(apollo.data)[0]) {
  const {data} = apollo

  return apollo.fetchMore({
    query,
    variables: {...variables, offset: data[key].results.length},
    updateQuery: (previousResult, {fetchMoreResult}) => {
      const oldResults = previousResult[key].results
      const newResults = fetchMoreResult[key].results
      const newFeed = uniqBy([...oldResults, ...newResults], "id")
      const newOffset = newFeed.length

      return {
        [key]: {
          ...fetchMoreResult[key],
          offset: newOffset,
          results: newFeed
        }
      }
    }
  })
}
